import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * ErrorBoundary Component
 * React error boundary with fallback UI and recovery option
 */
import { Component } from 'react';
import { Button } from './Button.js';
import { Card } from './Card.js';
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
        };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error);
        console.error('Component stack:', errorInfo.componentStack);
        this.setState({ errorInfo });
        this.props.onError?.(error, errorInfo);
    }
    handleReset = () => {
        this.setState({
            hasError: false,
            error: null,
            errorInfo: null,
        });
        this.props.onReset?.();
    };
    render() {
        const { hasError, error } = this.state;
        const { children, fallback } = this.props;
        if (hasError) {
            if (fallback) {
                return fallback;
            }
            return (_jsx("div", { className: "min-h-[400px] flex items-center justify-center p-8", children: _jsxs(Card, { className: "max-w-lg w-full text-center", children: [_jsx("div", { className: "mx-auto w-16 h-16 bg-gray-100 dark:bg-slate-700 rounded-full flex items-center justify-center mb-4", children: _jsx("svg", { className: "w-8 h-8 text-gray-500 dark:text-slate-400", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" }) }) }), _jsx("h2", { className: "text-xl font-semibold text-gray-900 dark:text-slate-100 mb-2", children: "Something went wrong" }), _jsx("p", { className: "text-gray-600 dark:text-slate-400 mb-6", children: error?.message || 'An unexpected error occurred. Please try again.' }), _jsx(Button, { variant: "primary", onClick: this.handleReset, children: "Try again" })] }) }));
        }
        return children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map